import { useNavigate } from "react-router-dom";
import { useCreateProjectWithFtlRoutes } from "./useCreateProjectWithFtlRoutes";
import { isArrayUndefinedOrEmpty } from "../../Utils/arrays";
import { ftlRouteUrls, projectUrls, ttProtectionUrls } from "../../URL/ApplicationUrls";
import { useCreateTtProtectionWithFtlRoutes } from "./useCreateTtProtectionWithFtlRoutes";

export const useFtlRoutesOverviewActions = () => {
  const navigate = useNavigate();

  // Navigate to details page
  const showDetails = (routeId: number | undefined) =>
    routeId && navigate(ftlRouteUrls.detailsFor(routeId));

  // Create Project
  const createProjectWithFtlRoutes = useCreateProjectWithFtlRoutes();
  async function createProject(routes: number[]) {
    if (isArrayUndefinedOrEmpty(routes)) return;
    const { newProjectId } = await createProjectWithFtlRoutes(routes);
    navigate(projectUrls.projectWithId(newProjectId).uiPath);
  }

  // Create TT Protection
  const createTtProtectionWithFtlRoutes = useCreateTtProtectionWithFtlRoutes();
  async function createTtProtection(routes: number[]) {
    if (isArrayUndefinedOrEmpty(routes)) return;
    const { newTtProtectionId } = await createTtProtectionWithFtlRoutes(routes);
    navigate(ttProtectionUrls.detailsFor(newTtProtectionId));
  }

  return {
    showDetails,
    createProject,
    createTtProtection,
  };
};
